import type { Answer } from './GameCollectionShelfPhoto'
import { useHorizontalScroll } from '../../composables/use-horizontal-scroll'
import { GameCollectionShelfPhoto } from './GameCollectionShelfPhoto'

export type ShelfRowData = {
  campaignId: string
  items: Answer[]
}

type Props = {
  columnCount?: number
  shelfRowData: ShelfRowData
  handleShelfPhotoClick: (answer: Answer) => void
}

export function GameCollectionShelfPhotoList(props: Props) {
  const { shelfRowData, columnCount = 10, handleShelfPhotoClick } = props

  const { scrollRef, isDragging, handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove, handleClick } = useHorizontalScroll()

  return (
    <div
      className="flex select-none gap-2 overflow-x-auto p-1 [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:bg-transparent"
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onClick={handleClick}
      ref={scrollRef}
    >
      {Array.from({ length: columnCount }).map((_, index) => (
        <GameCollectionShelfPhoto
          key={`${shelfRowData.campaignId}-${index + 1}`}
          isDragging={isDragging}
          answer={shelfRowData.items[index]}
          handleShelfPhotoClick={handleShelfPhotoClick}
        />
      ))}
    </div>
  )
}
